import React, {useEffect} from "react";
import {Button, makeStyles, Typography} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {addToCart} from "../reducers/Configuration/Actions";
import { useTranslation } from "react-i18next";
import { createScreenshot } from "../Utils/CreateScreenshot";
import clsx from "clsx";
import RequestOfferDialog from "./RequestOfferDialog";

const useStyles = makeStyles({
  footer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    marginRight: 20,
    bottom: 0,
    right: 0,
    position: "absolute",
  },
  price: { display: "flex", flexDirection: "column", marginRight: 10 },
  addToCart: {
    height: 40,
    color: "#fff",
    minWidth: 140,
    textTransform: "none",
    fontWeight: "bold",
    "&:hover": {
      opacity: 0.6,
    },
    "&.Mui-disabled": {
      opacity: 0.3,
      color: "#fff",
    },
  },
});
export default function AddToCart(props) {
  const classes = useStyles(props);
  const dispatch = useDispatch();
  const { t } = useTranslation(["common"]);
  const price = useSelector((state) => {
    return state.Configuration.calculation.price;
  });
  const { isLoading, configuration } = useSelector((state) => state.Configuration);
  const callToAction = configuration && configuration.item ? configuration.item.callToAction : null;
  const itemIdentifier = configuration && configuration.item ? configuration.item.identifier : "";
  const saveCartInfo = async () => {
    const screenshot = await createScreenshot(itemIdentifier.includes("artus"));
    dispatch(addToCart(screenshot));
  };

  const [isRequestFormOpen, setIsRequestFormOpen] = React.useState(false);

  const formattedPrice =
    typeof price === "number"
      ? new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(price))
      : "0 €";


  const renderPriceComponent = () => {
    return (
        <div className={classes.price}>
          <Typography variant="h5" align="right">
            <b>{formattedPrice}</b>
          </Typography>
          <Typography variant="caption" gutterBottom={true} align="right">
            <i>{t("price")}</i>
          </Typography>{" "}
        </div>
    )
  };

  const renderAddToCard = () => {
    return (
        <Button
            variant="contained"
            disabled={isLoading}
            className={clsx(classes.addToCart, "primaryButton")}
            onClick={() => saveCartInfo()}
        >
          {t("addToCart")}
        </Button>
    )
  };
  const renderOfferRequest = () => {
    return (
        <div>
          <Button
              variant="contained"
              disabled={isLoading}
              className={clsx(classes.addToCart, "primaryButton")}
              onClick={() => setIsRequestFormOpen(true)}
          >
            {t("offerRequest")}
          </Button>
          {isRequestFormOpen &&
              <RequestOfferDialog
                  onClose={() => setIsRequestFormOpen(false)}
                  formattedPriceElement={renderPriceComponent}
              />
          }
        </div>
    )
  }

  return (
    <div className={classes.footer}>
      {renderPriceComponent()}
      {callToAction === "requestOffer" ? renderOfferRequest() : renderAddToCard()}
    </div>
  );
}
